import PropTypes from "prop-types";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Table from "../../Tables/Table";

import { getBybetjenter as getBybetjenterAction } from "../../../../actions/bybetjenterActions";
import { getIleggelseRettelser as getIleggelseRettelserAction } from "../../../../actions/ileggelseRettelserActions";

import { getIleggelseRettelser } from "../../../../selectors/ileggelseTilbakameldingerFraBybetjenter";

import { toNorwegianDatetime } from "../../../../utils/date";

export default function TilbakemeldingerFraBybetjenterContainer({
  ileggelseId,
}) {
  const ileggelseRettelser = useSelector(getIleggelseRettelser);
  const bybetjenter = useSelector((state) => state.bybetjenter);
  const dispatch = useDispatch();

  useEffect(() => {
    if (ileggelseId) dispatch(getIleggelseRettelserAction(ileggelseId));
    if (bybetjenter.length === 0) dispatch(getBybetjenterAction());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const renderRow = (ileggelseRettelse) => (
    <tr key={ileggelseRettelse.id}>
      <td>
        {ileggelseRettelse.rettelseDato &&
          toNorwegianDatetime(ileggelseRettelse.rettelseDato).format(
            "DD.MM.YYYY HH:mm",
          )}
      </td>
      <td>{ileggelseRettelse.tjenestenummer}</td>
      <td>{ileggelseRettelse.rettelse}</td>
      <td>{ileggelseRettelse.kommentar}</td>
    </tr>
  );

  return (
    <section>
      <div className="detalj-ileggelse-header-wrapper">
        <h2>Tilbakemelding</h2>
      </div>
      <div className="detalj-ileggelse-table-wrapper">
        <Table renderRow={renderRow} items={ileggelseRettelser}>
          <th>Dato</th>
          <th>Tjenestenummer</th>
          <th>Rettelse</th>
          <th>Kommentar</th>
        </Table>
      </div>
    </section>
  );
}

TilbakemeldingerFraBybetjenterContainer.propTypes = {
  ileggelseId: PropTypes.string,
};
